import React from 'react';
import AdpPrivateCloudSnowflakeUpload from "./AdpPrivateCloudSnowflakeUpload";

export const GEO_MARKET_TABLES_TO_INCLUDE = [
    "prop_combined_geography_parentage",
    "prop_dim_geography",
    "prop_geography_hierarchy"
];

const AdpGeoMarketPublish = () =>
    <AdpPrivateCloudSnowflakeUpload pageName={"ADP Geo/Market Publishing"}
                                    extraDagConfig={{tables_to_include: GEO_MARKET_TABLES_TO_INCLUDE}}/>;

export default AdpGeoMarketPublish;
